/*
Copyright 2020 DigitalOcean

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

export default {
    title: 'JavaScript Minify Tool',
    description: 'A web tool for the DigitalOcean Community to quickly minify JavaScript files.',
    liveCompression: 'Enable live compression as you type',
    compress: 'Compress Code',
    input: 'Input JavaScript',
    errors: 'Errors',
    warnings: 'Warnings',
    output: 'Output JavaScript',
    map: 'Source Map',
    mapTitle: 'Generated Source Map',
    errorMsg: 'An error occurred during minification',
    warningMsg: 'A warning was generated during the minification',
    warningsMsg: 'Some warnings were generated during the minification',
    oss: 'This tool is {link|open-source on GitHub|https://github.com/do-community/minify-tool} under the {link|Apache-2.0|https://github.com/do-community/minify-tool/blob/master/LICENSE} license! We welcome feedback and contributions.',
};
